/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Task_NextInputs */

const en_inbox_na_task_next = /** @type {(inputs: Inbox_Na_Task_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work on the next step`)
};

const id_inbox_na_task_next = /** @type {(inputs: Inbox_Na_Task_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerjakan langkah berikutnya`)
};

/**
* | output |
* | --- |
* | "Work on the next step" |
*
* @param {Inbox_Na_Task_NextInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_task_next = /** @type {((inputs?: Inbox_Na_Task_NextInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Task_NextInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_task_next(inputs)
	return en_inbox_na_task_next(inputs)
});